import React from 'react';
import RezRATE from '../../../../../Body/RezRATE/RezRATE';

const SyntheticEvaluation = (props) => {
  return <RezRATE {...props} isEmbedded={true} />;
};

export default SyntheticEvaluation;
